/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import { toast } from 'react-toastify';
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup, Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "../IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}-${new Date().getTime()}`,
    content: `item ${k + offset}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF"),
  display:'flex',
  width:'100%',
  // styles we need to apply on draggables
  ...draggableStyle
});
const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  borderBottom: '6px solid #091E3F',
  minHeight:'80px',
  // marginBottom:'20px'
});

function Index(props) {
  const [state, setState] = useState([getItems(10), getItems(5, 10)]);
  const [tableData, setTableData] = useState([]);
  const [newPassword, setNewPassword] = useState("")
  const [email, setEmail] = useState("")  
  const [newConfirmPassword, setNewConfirmPassword] = useState("")
  const [changeConfirm, setChangeConfirm] = useState(false);
  
  const main = useRef();
  const [modal, setModal] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const logoRef = useRef(null);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      setEmail(userinfo['email'])
      setNewConfirmPassword(null)
    }
  },[]);

  function onDragEnd(result) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;

    if (sInd === dInd) {
      const items = reorder(state[sInd], source.index, destination.index);
      const newState = [...state];
      newState[sInd] = items;
      setState(newState);
    } else {
      const result = move(state[sInd], state[dInd], source, destination);
      const newState = [...state];
      newState[sInd] = result[sInd];
      newState[dInd] = result[dInd];

      setState(newState.filter(group => group.length));
    }
  }


  const submitForm=()=>{
    if(newConfirmPassword != newPassword){
      toast.error("The password is not matching");
      return;
    }
    var bodyFormData = new FormData();
    const user = localStorage.getItem('user_bigbrand');
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      bodyFormData.append('email', email);
      bodyFormData.append('password', newPassword);
      axios.post(`/users/setpassword/${userinfo.id}`, bodyFormData).then(res => {
        setChangeConfirm(false)
        const result = res.data;
        if(result.status == "success"){        
          toast.success("The password has been changed");
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
    }
  }

  const onChangeLogo=(e)=>{
    setLogoImage(URL.createObjectURL(e.target.files[0]))
  }
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col  md="12">
              <div style={{marginTop:'65px', borderRadius:'5px', background:'white'}}>
                  <h5 className="p-3">Account</h5>
                  <Row>
                    <Col md="6">
                      <Card className="bg-white border-0">
                        <CardBody style={{padding:'1rem 1.5rem'}}>
                          {/* <h6 className="mt-0 mb-2 font-weight-bold">Account</h6> */}
                          <FormGroup row>
                            <Col sm={5}>
                              <label size="sm">Email:</label>
                            </Col>
                            <Col sm={7}>
                              <Input type="email" bsSize="sm" name="email" value={email} onChange={(e)=>setEmail(e.target.value)} autoComplete="off" placeholder="email"/> 
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Col sm={5}>
                              <label size="sm">New Password:</label>
                            </Col>
                            <Col sm={7}>
                              <Input type="password" bsSize="sm" name="new_password" value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} autoComplete="off" placeholder="password"/> 
                            </Col>
                          </FormGroup>
                          <FormGroup row> 
                            <Col sm={5}>
                              <label size="sm">Confirm Password:</label>
                            </Col>
                            <Col sm={7}>
                              <Input type="password" bsSize="sm" name="new_password_confirm" value={newConfirmPassword} onChange={(e)=>setNewConfirmPassword(e.target.value)} autoComplete="off"/> 
                            </Col>
                          </FormGroup>
                          <FormGroup className="text-right mb-0">
                            <Button  className="" color="primary" size="sm" onClick={()=>setChangeConfirm(true)}>Change</Button>
                          </FormGroup>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
            </Col>
          </Row>
          <Modal isOpen={changeConfirm} toggle={()=>setChangeConfirm(false)} >
          <ModalHeader toggle={()=>setChangeConfirm(false)}>Confirm</ModalHeader>
          <ModalBody>
            Are you sure to change the information?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" size="sm" onClick={()=>submitForm()}>Yes</Button>{' '}
            <Button color="secondary" size="sm" onClick={()=>setChangeConfirm(false)}>No</Button>
          </ModalFooter>
        </Modal>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
